// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--3IMEZ","text":"dd31006766--text--1WLyN","close-icon":"dd31006766--close-icon--3JhJT"};